import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, HostListener, Inject, OnInit, ViewChild, DOCUMENT } from '@angular/core';
import { NavigationService } from 'src/core/services/navigation.service';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/core/services/auth.service';
import { ModalChange } from 'src/core/types/modal.types';
import { MsalService } from '@azure/msal-angular';
import { filter, forkJoin, map, merge, of, skip, take, tap, withLatestFrom } from 'rxjs';
import { LoadingService } from 'src/core/services/loading.service';
import { ChatbotComponent } from "../chatbot/chatbot.component";
import { DataService } from 'src/core/services/data.service';
import { ChathistoryComponent } from "../chathistory/chathistory.component";
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { FunclocComponent } from "../widgets/funcloc/funcloc.component";
import { DeviceService } from 'src/core/services/device.service';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { InstrumentComponent } from "../widgets/instrument/instrument.component";
import { ModalService } from 'src/core/services/modal.service';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from 'src/core/services/search.service';
import { SessionService } from 'src/core/services/session.service';
import { ChatService } from 'src/core/services/chat.service';
import { SubscriptionService } from 'src/core/services/subscription.service';
import { ServiceHistoryComponent } from '../widgets/service-history/service-history.component';
import { ServiceMetricsComponent } from '../widgets/service-metrics/service-metrics.component';
import { WorkAreaComponent } from '../bottom-area/work-area/work-area.component';
import { environment } from 'src/environments/environment';
import { HeaderWidgetComponent } from '../widgets/header-widget/header-widget.component';
import { BookmarkMenuComponent } from '../bookmark-menu/bookmark-menu.component';
import { BookmarkService } from 'src/core/services/bookmark.service';
import { UserData } from 'src/core/types/user.types';
import { SubscribedNotificationsComponent } from '../alerts-and-notifications/subscribed-notifications/subscribed-notifications.component';
import { AutocheckComponent } from '../modals/autocheck/autocheck.component';
import { MaintenanceComponent } from '../modals/maintenance/maintenance.component';
import { HelpModalComponent } from '../modals/help-modal/help-modal.component';
import { ExactSystem, SelectedSystem, SystemIBase } from 'src/core/types/selectedSystem.types';
import { SystemHealthOverview } from 'src/core/types/systemhealth.types';
import { ServiceHistoryOverview } from 'src/core/types/servicehistory.types';
import { ServiceMetricsOverview } from 'src/core/types/servicemetrics.types';
import { MsNotificationsDetailsComponent } from '../bottom-area/service-history-details/ms-notifications/ms-notifications-details/ms-notifications-details.component';
import { ApiResponse } from 'src/core/types/general.types';
import { PsmComponent } from '../modals/psm/psm.component';
import { ErrorComponent } from '../modals/error/error.component';
import { WidgetService } from 'src/core/services/widget.service';
import { MaintenanceFailureReasonsComponent } from '../modals/maintenance/maintenance-failure-reasons/maintenance-failure-reasons.component';
import { AppConfigService } from 'src/core/services/appconfig.service';
import { EventLogsComponent } from '../modals/event-logs/event-logs.component';
import { ThemeService } from 'src/core/services/thememanager.service';

import { SelectedContentService } from 'src/core/services/selectedcontent.service';
import { SelectedSiteService } from 'src/core/services/selectedsite.service';
import { ExactSite, SelectedSite } from 'src/core/types/selectedSite.types';
import { UpcomingActivitiesComponent } from '../widgets/upcoming-activities/upcoming-activities.component';
import { Title } from '@angular/platform-browser';
import { BusinessPartnerManagementComponent } from '../business-partner-management/business-partner-management.component';
import { BusinessPartnerAccessService } from 'src/core/services/business-partner-access.service';
import { InstrumentLastUpdatedComponent } from '../modals/instrument-last-updated/instrument-last-updated.component';
import { EmptyState } from "@shui/angular";
import { UserValidationStatus } from 'src/core/types/user.types';
import { BusinessPartnerAccessMatchType, BusinessPartnerRequiredRoleType } from 'src/core/types/business-partner.types';
import { ImagePreviewComponent } from '../modals/image-preview/image-preview.component';
import { Language, LanguageService } from 'src/core/services/language.service';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ChatPipModeComponent } from '../chat-pip-mode/chat-pip-mode.component';
import { IdleTimeoutService } from 'src/core/services/idle-timeout.service';
import {InfoModalComponent} from '../modals/info-modal/info-modal.component';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';

export type WidgetId = 'header' | 'instrument' | 'upcoming' | 'service-history' | 'funcloc' | 'service-metrics';
type LegalDocumentKind = 'termsOfUse' | 'privacyNotice';
type LegalDocumentLanguage = 'en' | 'zh' | 'ja' | 'pt' | 'es';

const DEFAULT_DEVICE_ORDER: WidgetId[] = ['instrument', 'upcoming', 'service-history', 'funcloc', 'service-metrics'];
const DEFAULT_SITE_ORDER: WidgetId[] = ['funcloc', 'upcoming', 'service-history', 'service-metrics'];
const SITE_ANCHOR_WIDGET: WidgetId = 'funcloc';

const STORAGE_KEY_DEVICE = 'axis-widget-order-device';
const STORAGE_KEY_SITE = 'axis-widget-order-site';
const SHAREPOINT_LEGAL_DOCUMENT_URLS: Record<LegalDocumentKind, string> = {
  termsOfUse: 'https://healthineers.sharepoint.com/SitePages/Terms-of-Use.aspx',
  privacyNotice: 'https://healthineers.sharepoint.com/SitePages/Siemens-Healthineers-Intranet-Data-Privacy-Notice.aspx',
};
const BUNDLED_LEGAL_DOCUMENT_PATH = '/assets/tou/legal-documents.html';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [CommonModule, DragDropModule, CdkScrollable, ChatbotComponent, ChathistoryComponent, FunclocComponent, AutocompleteComponent, InstrumentComponent, HeaderWidgetComponent, ServiceHistoryComponent, ServiceMetricsComponent, WorkAreaComponent, BookmarkMenuComponent, SubscribedNotificationsComponent, AutocheckComponent, MaintenanceComponent, HelpModalComponent, MsNotificationsDetailsComponent, PsmComponent, ErrorComponent, MaintenanceFailureReasonsComponent, EventLogsComponent, UpcomingActivitiesComponent, BusinessPartnerManagementComponent, InstrumentLastUpdatedComponent, EmptyState, ImagePreviewComponent, TranslocoModule, ChatPipModeComponent, InfoModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeComponent implements OnInit {
  private readonly licensepagePath = 'assets/tou/ReadMe_OSS-LicenseInfo-Artificial eXpert Insight System Web app (AXIS)-2.2.html';
  private readonly chatOnlyNotificationId = 'businessPartnerChatOnlySelectionBlocked';
  private get chatOnlyNotificationMessage(): string {
    return this.translocoService.translate('home.notification.chatOnlyMode.message');
  }
  isallowed: boolean = false;
  releaseNotes;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private msalService: MsalService,
    private dataService: DataService,
    @Inject(DOCUMENT) public document: Document,
    private loadingService: LoadingService,
    private selectedsystemService: SelectedsystemService,
    private deviceService: DeviceService,
    private route: ActivatedRoute,
    private searchService: SearchService,
    private sessionService: SessionService,
    private chatService: ChatService,
    private subscriptionService: SubscriptionService,
    private bookmarkService: BookmarkService,
    private widgetService: WidgetService,
    private themeService: ThemeService,
    public selectedContentService: SelectedContentService,
    private selectedSiteService: SelectedSiteService,
    private browsertitle: Title,
    private navigationService: NavigationService,
    private bpAccessService: BusinessPartnerAccessService,
    private languageService: LanguageService,
    private translocoService: TranslocoService,
    private idleTimeoutService: IdleTimeoutService
  ) {
    this.isInitialLoading = this.loadingService.$isInitialLoading.value;
  }

  @ViewChild('settings') settings: ElementRef;
  @ViewChild('noticenter') noticenter: ElementRef;
  @ViewChild('popover') popover: ElementRef;
  @ViewChild('leftpane') leftpane: ElementRef;
  @ViewChild('langTrigger') langTrigger: ElementRef;

  @ViewChild('bookmarkicon') bookmarkicon: ElementRef;
  @ViewChild('bookmarkmenu') bookmarkmenu: ElementRef;
  bookmarksOpen: boolean;

  // Language
  currentLanguage: Language = this.languageService.language;
  supportedLanguages: Language[] = this.languageService.languages;
  langPopoverVisible: boolean = false;
  private langSub: any;

  //User Data
  userData: UserData;
  allowed: boolean = true;
  theme: string = "light";
  initialVariable = 0;

  //App Data
  title: string = "LS Service Copilot - Web";
  widgetToken: string = "";
  isInitialLoading: boolean;
  isInitialError: boolean;
  isContentLoading: boolean = false;
  screenInfo$ = this.deviceService.screenInfo$; // expose observable
  defineModalSize = this.deviceService.defineModalSize;
  definePaneSizeLeft = this.deviceService.definePaneSizeLeft;
  definePaneSizeRight = this.deviceService.definePaneSizeRight;
  getDeviceType = this.deviceService.getDeviceType;
  paneSizeRight: string;
  paneSizeLeft: string;
  isSystemLoading: string;
  modalOpen: ModalChange;
  helpModalOpen: ModalChange;
  modalTracking: { open: boolean, type: string } = { open: false, type: "existinguser" };
  modalSubscriptions: { open: boolean, type: string } = { open: false, type: "default" };
  businessPartnerManagerOpen: boolean = false;
  readonly environment = environment;
  trackingConsentStep: 1 | 2 = 1;
  termsOfUseAccepted = false;
  consentBool: boolean = true;
  hasNewNotifications: boolean = false;
  numberOfNotifications: number = 0;

  errorBookmark: boolean = false;
  @ViewChild('paneTools') tools: ElementRef;
  @ViewChild('paneItems') items: ElementRef;

  // Idle session timeout
  idleWarningSeconds$ = this.idleTimeoutService.warning$;

  onStayLoggedIn(): void {
    this.idleTimeoutService.stayLoggedIn();
  }

  shouldUseCombinedPortugueseFlag(lang: Language | null | undefined): boolean {
    return lang?.code === 'pt';
  }

  // Business Partner capability getters — only active when environment.businessPartnerMode is true
  get bpAccessDenied(): boolean {
    return environment.businessPartnerMode && this.bpAccessService.isDenied;
  }

  get bpIsOnboarded(): boolean {
    return environment.businessPartnerMode && this.bpAccessService.isOnboarded;
  }

  get bpOnboardingMatchType(): BusinessPartnerAccessMatchType | null {
    if (!environment.businessPartnerMode) {
      return null;
    }

    return this.bpAccessService.onboardingMatchType;
  }

  get bpRequiredAccessRoleType(): BusinessPartnerRequiredRoleType | null {
    if (!environment.businessPartnerMode) {
      return null;
    }

    return this.bpAccessService.requiredAccessRoleType;
  }

  get bpResolvedCompanyName(): string | null {
    if (!environment.businessPartnerMode || !this.bpIsOnboarded) {
      return null;
    }

    const companyName = `${this.bpAccessService.companyName ?? ''}`.trim();
    return companyName || null;
  }

  get userIdentifierInfo(): string {
    const defaultInfo = `${this.userData?.basic?.['department'] ?? ''}`.trim();

    if (!environment.businessPartnerMode) {
      return defaultInfo;
    }

    return this.bpResolvedCompanyName ?? defaultInfo;
  }

  get requestedAccessRole(): string {
    const defaultRole = 'DX AXIS Internal Employees (LS Service Copilot)';

    if (!environment.businessPartnerMode) {
      return defaultRole;
    }

    const businessPartnerMailAuthRole = `${(environment as { businessPartnerMailAuthRole?: string }).businessPartnerMailAuthRole ?? ''}`.trim();
    const businessPartnerDomainAuthRole = `${(environment as { businessPartnerDomainAuthRole?: string }).businessPartnerDomainAuthRole ?? ''}`.trim();

    if (this.bpRequiredAccessRoleType === 'business-partner-mail') {
      return businessPartnerMailAuthRole || businessPartnerDomainAuthRole || defaultRole;
    }

    if (this.bpRequiredAccessRoleType === 'business-partner-domain') {
      return businessPartnerDomainAuthRole || businessPartnerMailAuthRole || defaultRole;
    }

    if (this.bpOnboardingMatchType === 'mail') {
      return businessPartnerMailAuthRole || businessPartnerDomainAuthRole || defaultRole;
    }

    if (this.bpOnboardingMatchType === 'domain') {
      return businessPartnerDomainAuthRole || businessPartnerMailAuthRole || defaultRole;
    }

    // Match type can be absent in partial/legacy backend responses.
    // In business partner mode always prefer business partner roles to avoid impossible internal-role requests.
    return businessPartnerMailAuthRole || businessPartnerDomainAuthRole || defaultRole;
  }

  get requestedAccessRoleTag(): string {
    return this.requestedAccessRole;
  }

  get hasRequestedAccessRole(): boolean {
    if (!environment.businessPartnerMode) {
      return !!this.userData?.authorized;
    }

    if (!this.bpIsOnboarded) {
      return false;
    }

    return this.authService.hasDirectoryGroup(this.requestedAccessRole);
  }

  get showMainApplication(): boolean {
    if (!this.userData) {
      return false;
    }

    if (!environment.businessPartnerMode) {
      return this.userData.authorized;
    }

    return this.bpIsOnboarded && this.hasRequestedAccessRole && !this.bpAccessError;
  }

  get showBusinessPartnerNotOnboardedState(): boolean {
    return environment.businessPartnerMode && !this.bpAccessError && this.bpAccessDenied;
  }

  get showRoleRequestState(): boolean {
    if (!this.userData) {
      return false;
    }

    if (!environment.businessPartnerMode) {
      return !this.userData.authorized;
    }

    return this.bpIsOnboarded && !this.hasRequestedAccessRole;
  }

  get roleRequestMessage(): string {
    return this.translocoService.translate('home.roleRequest.message');
  }

  get bpAccessError(): boolean {
    return environment.businessPartnerMode && this.bpAccessService.isError;
  }

  get bpCanChatbot(): boolean {
    if (!environment.businessPartnerMode) return true;
    return this.bpAccessService.access?.chatbot ?? false;
  }

  get bpShowDisabledChatbot(): boolean {
    return environment.businessPartnerMode && !this.bpCanChatbot;
  }

  get bpCanMachineData(): boolean {
    return this.bpAccessService.canViewMachineData;
  }

  get bpCanServiceData(): boolean {
    return this.bpAccessService.canViewServiceData;
  }

  get bpCanSearchContent(): boolean {
    return this.bpCanMachineData || this.bpCanServiceData;
  }

  get bpIsChatOnlyMode(): boolean {
    return environment.businessPartnerMode && !this.bpCanSearchContent;
  }

  get bpCanViewDeviceLocation(): boolean {
    return this.bpAccessService.canViewDeviceLocation;
  }

  get bpShowBusinessPartnerManagerEntry(): boolean {
    if (environment.businessPartnerMode) {
      return false;
    }

    return this.authService.hasSingleBusinessPartnerManagerRegionRole()
      || this.authService.hasMultipleBusinessPartnerManagerRegionRoles();
  }

  get bpCanManageBusinessPartners(): boolean {
    return !environment.businessPartnerMode && this.authService.hasSingleBusinessPartnerManagerRegionRole();
  }

  get showServiceMetricsWidget(): boolean {
    return environment.enableServiceMetricsWidget;
  }

  // ── Widget ordering (drag & drop) ──────────────────────────────────────

  deviceWidgetOrder: WidgetId[] = this.loadWidgetOrder('device');
  siteWidgetOrder: WidgetId[] = this.loadWidgetOrder('site');

  /** Visible device widgets in user-defined order, filtered by permissions + loading gates. */
  get visibleDeviceWidgets(): WidgetId[] {
    return this.deviceWidgetOrder.filter(id => this.isDeviceWidgetVisible(id));
  }

  /** Visible site widgets in user-defined order, filtered by permissions. */
  get visibleSiteWidgets(): WidgetId[] {
    return this.siteWidgetOrder.filter(id => id !== SITE_ANCHOR_WIDGET && this.isSiteWidgetVisible(id));
  }

  /** Locked device widgets — those the user doesn't have permission for. */
  get lockedDeviceWidgets(): WidgetId[] {
    return this.deviceWidgetOrder.filter(id => this.isDeviceWidgetLocked(id));
  }

  /** Locked site widgets. */
  get lockedSiteWidgets(): WidgetId[] {
    return this.siteWidgetOrder.filter(id => this.isSiteWidgetLocked(id));
  }

  private isDeviceWidgetVisible(id: WidgetId): boolean {
    switch (id) {
      case 'instrument': return this.bpCanMachineData && !this.isContentLoading;
      case 'upcoming': return this.bpCanServiceData;
      case 'service-history': return this.bpCanServiceData && !this.isContentLoading;
      case 'funcloc': return this.bpCanViewDeviceLocation && !this.isContentLoading;
      case 'service-metrics': return this.bpCanServiceData && this.showServiceMetricsWidget && !this.isContentLoading;
      default: return false;
    }
  }

  private isSiteWidgetVisible(id: WidgetId): boolean {
    switch (id) {
      case 'funcloc': return true;
      case 'upcoming': return this.bpCanServiceData;
      case 'service-history': return this.bpCanServiceData && !this.isContentLoading;
      case 'service-metrics': return this.bpCanServiceData && this.showServiceMetricsWidget && !this.isContentLoading;
      default: return false;
    }
  }

  private isDeviceWidgetLocked(id: WidgetId): boolean {
    switch (id) {
      case 'instrument': return !this.bpCanMachineData;
      case 'funcloc': return !this.bpCanViewDeviceLocation;
      case 'upcoming': return !this.bpCanServiceData;
      case 'service-history': return !this.bpCanServiceData;
      case 'service-metrics': return !this.bpCanServiceData && this.showServiceMetricsWidget;
      default: return false;
    }
  }

  private isSiteWidgetLocked(id: WidgetId): boolean {
    switch (id) {
      case 'upcoming': return !this.bpCanServiceData;
      case 'service-history': return !this.bpCanServiceData;
      case 'service-metrics': return !this.bpCanServiceData && this.showServiceMetricsWidget;
      default: return false;
    }
  }

  dragPlaceholderHeight = 200;

  onDragHandlePointerDown(event: Event): void {
    const handle = event.currentTarget as HTMLElement;
    const dragItem = handle.closest('.widget-drag-item');
    if (dragItem) {
      this.dragPlaceholderHeight = dragItem.getBoundingClientRect().height;
    }
  }

  onWidgetDrop(event: CdkDragDrop<WidgetId[]>, view: 'device' | 'site'): void {
    const list = view === 'device' ? this.visibleDeviceWidgets : this.visibleSiteWidgets;
    moveItemInArray(list, event.previousIndex, event.currentIndex);

    let newOrder: WidgetId[];
    if (view === 'device') {
      // Rebuild full order: reordered visible widgets first, then any hidden/locked ones keep their relative position
      const remaining = DEFAULT_DEVICE_ORDER.filter(id => !list.includes(id));
      newOrder = [...list, ...remaining];
    } else {
      // Site view keeps funcloc pinned as anchor widget.
      const siteMovableDefaults = DEFAULT_SITE_ORDER.filter(id => id !== SITE_ANCHOR_WIDGET);
      const remaining = siteMovableDefaults.filter(id => !list.includes(id));
      newOrder = [SITE_ANCHOR_WIDGET, ...list, ...remaining];
    }

    if (view === 'device') {
      this.deviceWidgetOrder = newOrder;
    } else {
      this.siteWidgetOrder = newOrder;
    }
    this.saveWidgetOrder(view, newOrder);
  }

  private loadWidgetOrder(view: 'device' | 'site'): WidgetId[] {
    const key = view === 'device' ? STORAGE_KEY_DEVICE : STORAGE_KEY_SITE;
    const defaults = view === 'device' ? DEFAULT_DEVICE_ORDER : DEFAULT_SITE_ORDER;
    try {
      const stored = localStorage.getItem(key);
      if (!stored) return [...defaults];
      const parsed: WidgetId[] = JSON.parse(stored);
      // Validate: must contain all default IDs, no unknown ones
      const defaultSet = new Set(defaults);
      const parsedSet = new Set(parsed);
      if (defaults.every(id => parsedSet.has(id)) && parsed.every(id => defaultSet.has(id))) {
        if (view === 'site') {
          return [SITE_ANCHOR_WIDGET, ...parsed.filter(id => id !== SITE_ANCHOR_WIDGET)];
        }
        return parsed;
      }
      return [...defaults];
    } catch {
      return [...defaults];
    }
  }

  private saveWidgetOrder(view: 'device' | 'site', order: WidgetId[]): void {
    const key = view === 'device' ? STORAGE_KEY_DEVICE : STORAGE_KEY_SITE;
    try {
      localStorage.setItem(key, JSON.stringify(order));
    } catch { }
  }

  get isBusinessPartnerNewUserConsentFlow(): boolean {
    return environment.businessPartnerMode && this.modalTracking.type === 'newuser';
  }

  get termsOfUsePdfUrl(): string {
    return this.getLegalDocumentUrl('termsOfUse');
  }

  get termsOfUseUrl(): string {
    return this.getLegalDocumentUrl('termsOfUse');
  }

  get privacyNoticeUrl(): string {
    return this.getLegalDocumentUrl('privacyNotice');
  }

  private getLegalDocumentUrl(kind: LegalDocumentKind): string {
    if (this.shouldUseSharePointLegalDocuments()) {
      return SHAREPOINT_LEGAL_DOCUMENT_URLS[kind];
    }

    return `${BUNDLED_LEGAL_DOCUMENT_PATH}?doc=${kind}&lang=${this.legalDocumentLanguage}`;
  }

  private shouldUseSharePointLegalDocuments(): boolean {
    return !environment.businessPartnerMode && this.legalDocumentLanguage === 'en';
  }

  private get legalDocumentLanguage(): LegalDocumentLanguage {
    const languageCode = this.currentLanguage?.code;

    if (languageCode === 'zh' || languageCode === 'ja' || languageCode === 'pt' || languageCode === 'es') {
      return languageCode;
    }

    return 'en';
  }


  //Serial Number Specific Data
  site: [any];
  selectedSystem: SelectedSystem = { SerialNumber: "", MaterialNumber: "", SupportType: "", LabName: "", Functional_Location_ID: "", ProductFamily: "" };
  selectedSite: SelectedSite = { Id: "", Name: "", SupportType: "" };
  
  selectedBottom: string;
  bottomSize: string;

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    this.handleBookmarksClick(event);
  }

  openLicensePage() {
    window.open(this.licensepagePath, '_blank');
  }
  private handleBookmarksClick(event: Event) {
    if (!this.bookmarkmenu || !this.bookmarkicon) return;
    const clickedInside = this.bookmarkmenu.nativeElement.contains(event.target);
    const clickedIcon = this.bookmarkicon.nativeElement.contains(event.target);

    if (!clickedInside && !clickedIcon) {

      if (this.bookmarkService.$bookmarksOpen.value) {
        this.bookmarkService.$bookmarksOpen.next(false);
      }
    }

  }

  ngOnInit(): void {

    this.title = environment.title;

    // Subscribe to available languages (feature-flag filtered)
    this.languageService.availableLanguages$.subscribe(langs => {
      this.supportedLanguages = langs;
    });

    // Keep flag icon in sync if language changes externally (e.g. feature-flag fallback)
    this.langSub = this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
    });

    //Get Recent Searches from Local Storage
    if (localStorage.getItem("recentsearches")) {
      this.searchService.recents.next(JSON.parse(localStorage.getItem("recentsearches")));
    };

    if(localStorage.getItem("recentsearchessites")) {
      this.searchService.recentsSites.next(JSON.parse(localStorage.getItem("recentsearchessites")));
    };

    //Get data about logged in user
    this.authService.getUserData()
      .subscribe(
        {
          next: (userData) => {
            this.userData = userData;

            // Start idle session timeout after successful authentication
            this.idleTimeoutService.start();

            if (environment.businessPartnerMode) {
              this.runStartupValidation(userData.basic['id']);
            } else {
              this.checkConsent(userData.basic['id']);
              this.initializeUrlParameterHandling();
            }

            if (!environment.businessPartnerMode) {
              this.loadingService.$isInitialLoading.next(false);
            }

          },
          error: (error) => {
            this.loadingService.$isInitialLoading.next(false);
            this.loadingService.$isInitialError.next(true);
          }
        }
      )

    //Listen for global loading state
    this.loadingService.$isInitialLoading.subscribe((isInitialLoading) => {
      this.isInitialLoading = isInitialLoading;
    });

    //Listen for global loading state
    this.loadingService.$isInitialError.subscribe((error) => {
      this.isInitialError = error;
    });

    //Listen if Modal is opened from somehwere
    this.modalService.$modalChanged.subscribe((modal) => {
      if (modal) {
        this.modalOpen = modal;
      }
    });

    //Listen to selected Bottom
    this.widgetService.$selectedWidget.subscribe({
      next: (widget) => {
        this.selectedBottom = widget;
      }
    });

    //Listen to selected Bottom
    this.widgetService.$workareaSize.subscribe({
      next: (size) => {
        this.bottomSize = size;
      }
    });


    // ---------------------------------------------------------------------------
    // Trigger Data Loads for new Selections in App (Systems or Sites)
    // ---------------------------------------------------------------------------

    // 1) reset / clear handling
    this.selectedContentService.selection$.pipe(
      skip(1),
      filter(sel => sel.kind === 'none'),
    ).subscribe(() => {
      this.selectedsystemService.resetAllData();
      this.loadingService.resetAllStates();

      // if you have site-specific caches/data, reset them here too
      this.selectedSiteService.resetAllData(); 

      //Reset Browser Title
      this.browsertitle.setTitle('Axis');

      this.widgetService.resetWidgets();
      this.sessionService.disconnect();
    });

    // 2) device flow (triggered both on device selection AND on refresh button)
    const selectedSystemOrRefresh$ = merge(
      this.selectedContentService.selectedSystem$,
      this.selectedsystemService.$reloadSelectedSystem.pipe(
        // Only the explicit refresh should put widgets back into a loading state
        tap(() => this.selectedsystemService.resetForReload()),
        withLatestFrom(this.selectedContentService.selectedSystem$),
        map(([, system]) => system),
      ),
    );

    selectedSystemOrRefresh$.pipe(
      filter((s): s is SelectedSystem => !!s?.SerialNumber?.trim()),
    ).subscribe(system => {
      if (system.SerialNumber + system.MaterialNumber !== this.selectedSystem?.SerialNumber + this.selectedSystem?.MaterialNumber) {

        this.sessionService.disconnect();

        this.sessionService.connect(
          this.deviceService.getDeviceType(),
          this.userData.basic["country"],
          this.userData.basic["department"],
          "device",
          system.SerialNumber,
          system.MaterialNumber,
          null,
          null
        );
      }

      //Reset and Setup Loading States
      this.selectedsystemService.resetForReload();
      this.selectedSiteService.resetForReload();

      this.selectedSystem = system;

      const selectedsystem = system.SerialNumber;
      const selectedmaterial = system.MaterialNumber;

      //Getting the current func loc id and check if it has changed
      this.dataService.searchExact(selectedmaterial, selectedsystem).subscribe(({ response, status }: ApiResponse<ExactSystem>) => {

        let currentLabId = response.Functional_Location_ID;

        this.dataService.searchExactSite(currentLabId).subscribe(({ response, status }: ApiResponse<ExactSite>) => {

          let selectedlab: string = response.is_current ? response.id : response.new_id;

          //Pull all data for selected system
          this.selectedsystemService.pullData(selectedmaterial, selectedsystem, selectedlab, 'device');

        });

      });


    });

    // 3) site flow (triggered both on site selection AND on refresh button)
    const selectedSiteOrRefresh$ = merge(
      this.selectedContentService.selectedSite$,
      this.selectedSiteService.$reloadSelectedSite.pipe(
        tap(() => this.selectedSiteService.resetForReload()),
        withLatestFrom(this.selectedContentService.selectedSite$),
        map(([, site]) => site),
      ),
    );

    selectedSiteOrRefresh$.pipe(
      filter((s): s is SelectedSite => !!s?.Id?.trim()),
    ).subscribe(site => {
      if (site.Id !== this.selectedSite.Id) {

        this.sessionService.disconnect();

        this.sessionService.connect(
          this.deviceService.getDeviceType(),
          this.userData.basic["country"],
          this.userData.basic["department"],
          "site",
          null,
          null,
          site.Id,
          site.Name
        );
      }

      //Reset and Setup Loading States
     /*  this.selectedsystemService.resetForReload();
      this.selectedSiteService.resetForReload(); */

      //Pull all Data for selected Site
      this.selectedSiteService.pullData(site.Id);

    });

    //Listen to Content Loading State
    this.selectedContentService.$isLoadingContent.subscribe((isLoading) => {
      this.isContentLoading = isLoading;
    });

    // Also listening to Bookmark Error to close module when needed
    this.bookmarkService.$bookmarkError.subscribe((error) => {
      this.errorBookmark = error;
    });

    //Check if Notification Center has new Notifications
    this.subscriptionService.$notificationsCenter.subscribe((notifications) => {
      this.hasNewNotifications = notifications.some(notification => !notification.read);
      this.numberOfNotifications = notifications.filter(notification => !notification.read).length;
    });

    //Listen for changes in the bookmark open
    this.bookmarkService.$bookmarksOpen.subscribe((open) => {
      this.bookmarksOpen = open
    });

    //Listen to error in Saving Chat
    this.chatService.errorSavingChat.subscribe({
      next: (bool) => {

        if (bool) {

          const current = this.subscriptionService.$notifications.getValue();
          const currentCenter = this.subscriptionService.$notificationsCenter.getValue();

          let entry = {
            id: "errorSavingChat",
            type: "warning",
            title: this.translocoService.translate('home.notification.cannotSaveChat.title'),
            message: this.translocoService.translate('home.notification.cannotSaveChat.message'),
            timestamp: new Intl.DateTimeFormat('en-US', {
              dateStyle: 'medium',
              timeStyle: 'short',
            }).format(new Date()),
            read: false
          };

          if (!currentCenter.some(notification => notification.id === "errorSavingChat")) {
            this.subscriptionService.$notifications.next([...current, entry]);
            this.subscriptionService.$notificationsCenter.next([...currentCenter, entry]);
          }
        }
      }
    });

    this.chatService.errorStreamingChat.subscribe({
      next: (bool) => {

        if (bool) {

          const current = this.subscriptionService.$notifications.getValue();
          const currentCenter = this.subscriptionService.$notificationsCenter.getValue();

          let entry = {
            id: "errorStreamingChat",
            type: "error",
            title: this.translocoService.translate('home.notification.cannotGetResponse.title'),
            message: this.translocoService.translate('home.notification.cannotGetResponse.message'),
            timestamp: new Intl.DateTimeFormat('en-US', {
              dateStyle: 'medium',
              timeStyle: 'short',
            }).format(new Date()),
            read: false
          };
          if (!currentCenter.some(notification => notification.id === "errorStreamingChat")) {
            this.subscriptionService.$notifications.next([...current, entry]);
            this.subscriptionService.$notificationsCenter.next([...currentCenter, entry]);
          }

        }
      }
    });

    this.modalService.$helpModalChanged.subscribe((modal) => {
      if (modal) {
        this.helpModalOpen = modal;
      }
    });

    // Subscribe to theme changes
    this.themeService.currentTheme$.subscribe(theme => {
      this.theme = theme;
    });

    if (environment.businessPartnerMode) {
        this.bpAccessService.accessState$.pipe(
        filter(state => state !== 'pending'),
        take(1),
      ).subscribe(() => this.applyInitialWidgetDefaults());
    }
   
  }

  private applyInitialWidgetDefaults(): void {
    if (this.bpCanViewDeviceLocation) {
      this.widgetService.$selectedWidget.next('bookmark');
      this.widgetService.$workareaSize.next('medium');
    } else {
      this.widgetService.$selectedWidget.next('None');
      this.widgetService.$workareaSize.next('small');
    }
  }


  openURL = (URL, event: Event) => {
    event.stopPropagation();
    window.open(URL, "_blank");
  }

  //Function that switches the theme
  // switchTheme = (clickedTheme) => {

  //   if (clickedTheme === 'light' && this.theme !== "light") {
  //     this.theme = "light";
  //     if (this.allowed) { localStorage.setItem("selectedtheme", "light") };
  //   } else if (clickedTheme === 'dark' && this.theme !== "dark") {
  //     this.theme = "dark";
  //     if (this.allowed) { localStorage.setItem("selectedtheme", "dark") };
  //   }
  //   //Keeps the window open when new theme is set
  //   setTimeout(() => this.keepOpen(), 1);
  //}

  switchTheme(): void {
    this.themeService.toggleTheme();
  }

  keepOpen = () => {
    if (this.initialVariable === 1) {
      this.popover.nativeElement.visible = true;
      this.settings.nativeElement.active = true;
    }
  }

  unToggle = () => {
    this.settings.nativeElement.active = false;
  }

  unToggleNoti = () => {
    this.noticenter.nativeElement.active = false;

    //Set all notifications to read
    //Reset all in Notificatio Window
    this.subscriptionService.$notifications.next([]);

    //Reset all in Center
    let temp = this.subscriptionService.$notificationsCenter.value;
    this.subscriptionService.$notificationsCenter.next(temp.map(notification => ({ ...notification, read: true })));


  }

  toggleLangPopover = () => {
    this.langPopoverVisible = !this.langPopoverVisible;
  }

  unToggleLang = () => {
    this.langPopoverVisible = false;
  }

  selectLanguage = (lang: Language) => {
    this.languageService.setLanguage(lang);
    this.currentLanguage = lang;
    this.langPopoverVisible = false;
  }

  onLogoutClick = () => {
    this.msalService.instance.logoutRedirect({
      postLogoutRedirectUri: '/login',
    });
  }

  openGAMA = () => {
    const roleTag = encodeURIComponent(this.requestedAccessRoleTag);
    window.open(`https://gama.healthcare.siemens.com/webCenterGAMA/directAccess.do?ac=assignServices&roleTag=${roleTag}`, "_blank", "noopener,noreferrer");
  }

  checkConsent(accountId: string) {
    this.authService.checkTrackingConsent(accountId).subscribe((consent) => {

      switch (consent) {
        case 'consented':
          this.authService.userData.consented = true;
          this.consentBool = true;
          this.userData = this.authService.userData;
          break;
        case 'denied':
          this.authService.userData.consented = false;
          this.consentBool = false;
          this.userData = this.authService.userData;
          break;
        case 'no-entry':
          this.openTrackingConsentModal('newuser');
          break;
        default:
          break;
      }
    });
  }

  runStartupValidation(accountId: string) {
    const accessValidation$ = environment.businessPartnerMode
      ? this.bpAccessService.checkAccess()
      : of(undefined);

    forkJoin({
      validation: this.authService.getUserValidation(accountId),
      access: accessValidation$,
    }).subscribe({
      next: ({ validation }) => {
        this.applyStartupValidation(validation);
        this.initializeUrlParameterHandling();
        this.loadingService.$isInitialLoading.next(false);
      },
      error: (error) => {
        console.error('Error validating startup requirements:', error);
        this.loadingService.$isInitialLoading.next(false);
      }
    });
  }

  retryBusinessPartnerAccess(): void {
    const accountId = this.authService.userData?.basic?.['id'];

    if (!accountId) {
      return;
    }

    this.loadingService.$isInitialLoading.next(true);
    this.runStartupValidation(accountId);
  }

  applyStartupValidation(validation: UserValidationStatus) {
    this.authService.userData.consented = validation.consent === 'consented';
    this.authService.userData.termsOfUseAccepted = validation.termsOfUseAccepted;

    if (validation.consent === 'consented') {
      this.consentBool = true;
    } else if (validation.consent === 'denied') {
      this.consentBool = false;
    }

    this.userData = this.authService.userData;

    const requiresTrackingSelection = validation.consent === 'no-entry';
    const requiresTermsOfUseAcceptance = environment.businessPartnerMode && !validation.termsOfUseAccepted;

    if (requiresTrackingSelection || requiresTermsOfUseAcceptance) {
      this.openTrackingConsentModal('newuser');
    }
  }

  initializeUrlParameterHandling() {
    this.route.queryParamMap
      .pipe(
        map(params => ({
          material: params.get('material'),
          serial: params.get('serial'),
          siteId: params.get('siteId')
        }))
      )
      .subscribe(({ material, serial, siteId }) => {
        const hasSelectionParams = (!!material && !!serial) || !!siteId;

        if (this.bpIsChatOnlyMode && hasSelectionParams) {
          this.showChatOnlyModeNotification();
          return;
        }

        if (material && serial) {
          this.selectedsystemService.setNewDevice(material, serial).subscribe({
            next: (newDevice) => {
              if (newDevice) { console.log('Selected Device from URL Params:', newDevice); }
            }
          });
        }

        if (siteId) {
          this.selectedSiteService.setNewSite(siteId).subscribe({
            next: (newSite) => {
              if (newSite) { console.log('Selected Site from URL Params:', newSite); }
            }
          });
        }
      });
  }

  showChatOnlyModeNotification() {
    const current = this.subscriptionService.$notifications.getValue();
    const currentCenter = this.subscriptionService.$notificationsCenter.getValue();

    const entry = {
      id: this.chatOnlyNotificationId,
      type: 'lock',
      title: this.translocoService.translate('home.notification.chatOnlyMode.title'),
      message: this.chatOnlyNotificationMessage,
      timestamp: new Intl.DateTimeFormat('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(new Date()),
      read: false
    };

    if (!currentCenter.some(notification => notification.id === this.chatOnlyNotificationId)) {
      this.subscriptionService.$notifications.next([...current, entry]);
      this.subscriptionService.$notificationsCenter.next([...currentCenter, entry]);
    }
  }

  closeModal() {
    this.modalService.$modalChanged.next({ modal: "", open: false });
  }

  closeHelpModal() {
    this.modalService.$helpModalChanged.next({ modal: "", open: false });
  }

  openModalTracking() {
    this.openTrackingConsentModal('existinguser');
  }

  closeModalTracking() {
    this.resetTrackingConsentFlow();
    this.modalTracking = { open: false, type: "existinguser" };
  }

  openTrackingConsentModal(type: 'existinguser' | 'newuser') {
    this.resetTrackingConsentFlow();
    this.modalTracking = { open: true, type };
  }

  resetTrackingConsentFlow() {
    this.trackingConsentStep = 1;
    this.termsOfUseAccepted = false;
  }

  goToTrackingConsentStep(step: 1 | 2) {
    if (!this.isBusinessPartnerNewUserConsentFlow) {
      return;
    }

    if (step === 1) {
      this.trackingConsentStep = 1;
      return;
    }

    if (this.termsOfUseAccepted) {
      this.trackingConsentStep = 2;
    }
  }

  goToPreviousTrackingConsentStep() {
    this.goToTrackingConsentStep(1);
  }

  goToNextTrackingConsentStep() {
    this.goToTrackingConsentStep(2);
  }

  toggleTermsOfUseAccepted() {
    this.termsOfUseAccepted = !this.termsOfUseAccepted;
  }

  getTermsOfUseStepState(): 'success' | undefined {
    if (this.isBusinessPartnerNewUserConsentFlow && this.trackingConsentStep === 2 && this.termsOfUseAccepted) {
      return 'success';
    }

    return undefined;
  }

  openModalSubscription() {
    this.modalSubscriptions = { open: true, type: "default" };
  }

  closeModalSubscription() {
    this.modalSubscriptions = { open: false, type: "default" };
  }

  openBusinessPartnerManager() {
    if (!this.bpCanManageBusinessPartners) {
      this.unToggle();
      return;
    }

    this.businessPartnerManagerOpen = true;
    this.unToggle();
  }

  closeBusinessPartnerManager() {
    this.businessPartnerManagerOpen = false;
  }

  changeConsent() {
    const request$ = this.isBusinessPartnerNewUserConsentFlow
      ? this.authService.updateUserValidation(this.userData.basic["id"], this.consentBool, true)
      : this.authService.updateTrackingConsent(this.userData.basic["id"], this.consentBool);

    request$.subscribe({
      next: (response) => {

        // Create new session with updated consent
        this.sessionService.disconnect();

        switch (this.consentBool) {
          case true:
            this.authService.userData.consented = true;
            this.userData = this.authService.userData;
            break;
          case false:
            this.authService.userData.consented = false;
            this.userData = this.authService.userData;
            break;
          default:

            break;
        }

        if (this.isBusinessPartnerNewUserConsentFlow) {
          this.authService.userData.termsOfUseAccepted = true;
          this.userData = this.authService.userData;
        }

        this.closeModalTracking();

      },
      error: (error) => {
        console.error("Error fetching consent:", error);
      }
    });
  }

  changeconsentBool = (bool: boolean) => {
    this.consentBool = bool;
  }

  newChat(e: any) {
    if (!this.bpCanChatbot && this.bpShowDisabledChatbot) {
      e?.stopPropagation?.();
      return;
    }

    if (e.target.icon === 'home') {
      this.navigationService.notifyHomeClicked();
    } else {
      this.widgetService.$chatPipSize.next('maximized');
    }
    Array.from(this.tools.nativeElement.children).forEach((child: any) => {
      if (child !== e.target) {
        child.active = false;
      }
      e.target.active = this.isLabelMatching(e.target.label, child.label);
      child.active = this.isLabelMatching(child.label, e.target.label);
    });
    Array.from(this.items.nativeElement.children).forEach((child: any) => {
      if (child !== e.target) {
        child.active = false;
      }
      child.active = this.isLabelMatching(e.target.label, child.label);

    });
    if (!this.chatService.isStreaminginProgress()) {
      {
        if (e.target.icon === 'home') {


          // when user clicks Refresh, re-emit the CURRENT selection into the same stream

          //Listen for new Instrument

          this.selectedContentService.clear();

          // If not streaming, it's safe to clear messages.
        }

        this.chatService.messages.next([]);
      }
    }
  }

  openChatHistory(e: any) {
    if (!this.bpCanChatbot && this.bpShowDisabledChatbot) {
      e?.stopPropagation?.();
      return;
    }

    Array.from(this.tools.nativeElement.children).forEach((child: any) => {
      if (child !== e.target) {
        child.active = false;
      }
    });
    Array.from(this.items.nativeElement.children).forEach((child: any) => {
      if (child !== e.target) {
        child.active = false;
      }
    });
    if (this.leftpane.nativeElement.size === "condensed") {
      this.leftpane.nativeElement.size = "expanded";
    } else {
      this.leftpane.nativeElement.size = "condensed";
    }
  }

  private isLabelMatching(targetLabel: string, childLabel: string): any {
    return targetLabel.toLowerCase().includes(childLabel.toLowerCase()) || childLabel.toLowerCase().includes(targetLabel.toLowerCase());
  }

  openBookmarks() {
    this.bookmarkService.$bookmarksOpen.next(true);
  }

  bookmarksClosed() {
    this.bookmarkService.$bookmarksOpen.next(false);
  }

  openHelp(section) {
    this.modalService.$helpModalChanged.next({ modal: section, open: true });
  }

  onMaximizeBookmarks(filter?: string) {
    if (this.widgetService.$workareaSize.value !== "small" && this.widgetService.$selectedWidget.value === "bookmark" && !filter) {
      this.widgetService.closeWidget();
      return;
    }
    this.navigationService.notifyBookmarkClicked();
    this.widgetService.expandWidget("bookmark", filter);
  }

}
